import { Divider } from 'antd';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { createArchiveUnarchiveActions } from './createArchiveUnarchiveActions';

/**
 * Creates show/edit/archive action buttons for invoice columns.
 * This eliminates code duplication between customer and intern invoice columns.
 * @function
 * @param {Object} params - Configuration parameters
 * @param {Function} params.t - Translation function
 * @param {Object} params.enums - Enums object containing status
 * @param {Object} params.record - The record object
 * @param {Function} params.deleteResource - Function to archive a resource
 * @param {Function} params.restoreResource - Function to unarchive a resource
 * @param {string} params.showPath - Path for the show link (e.g., '/invoices/customers/show')
 * @param {string} params.editPath - Path for the edit link (e.g., '/invoices/customers/edit')
 * @returns {JSX.Element} Show/edit/archive action buttons
 */
export const createInvoiceShowEditActions = ({
  t,
  enums,
  record,
  deleteResource,
  restoreResource,
  showPath,
  editPath
}) => (
  <>
    <Link
      to={{
        pathname: `${showPath}/${record?._id}`
      }}
    >
      <EyeOutlined style={{ fontSize: 18 }} />
    </Link>
    {enums.status && ['UNPAID', 'WAITING'].includes(record.status) && (
      <>
        <Divider type="vertical" />
        <Link
          to={{
            pathname: `${editPath}/${record?._id}`
          }}
        >
          <EditOutlined style={{ fontSize: 18 }} />
        </Link>
      </>
    )}
    {createArchiveUnarchiveActions({
      t,
      deleteResource,
      restoreResource,
      record
    })}
  </>
);
